"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.render = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _lodash = _interopRequireDefault(require("lodash"));

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _i18n = require("../../components/i18n");

var _router = require("../../components/router");

var _analytics = require("../../modules/analytics");

var _auth = require("../../modules/auth");

var _NotificationsProvider = _interopRequireDefault(require("../../components/ui/notifications/NotificationsProvider"));

var _GlobalComponentsContext = require("../../components/global/GlobalComponentsContext");

var _GlobalErrorHandler = _interopRequireDefault(require("../../components/global/GlobalErrorHandler"));

var getReducers = function getReducers(_module) {
  var key = _module.key,
      reducer = _module.reducer;

  if (reducer) {
    var _ref;

    return _ref = {}, _ref[key] = reducer, _ref;
  }

  return {};
};

var getMessages = function getMessages(_ref2) {
  var messages = _ref2.messages;

  if (messages) {
    return messages;
  }
};

var getRoutes = function getRoutes(_module) {
  if (_module.routes) {
    return _module.routes;
  }

  return [];
};

var getMenuItems = function getMenuItems(_module) {
  var menuItems = [];

  if (_module.routes) {
    var filterValidMenu = function filterValidMenu(menu) {
      return Boolean(menu);
    };

    var menuMapper = function menuMapper(route) {
      var menuItem = null;
      var menu = route.menu,
          path = route.path,
          subroutes = route.subroutes;

      if (menu) {
        menuItem = (0, _extends2.default)({}, menu, {
          to: path
        });

        if (subroutes) {
          menuItem.menu = subroutes.map(function (subroute) {
            return Object.assign({}, subroute, {
              path: "" + route.path + subroute.path
            });
          }).map(menuMapper).filter(filterValidMenu);
        }
      }

      return menuItem;
    };

    menuItems = _module.routes.map(menuMapper).filter(filterValidMenu);
  }

  return menuItems;
};

var moduleReducer = function moduleReducer(_ref3, _module) {
  var menu = _ref3.menu,
      routes = _ref3.routes,
      messages = _ref3.messages,
      reducers = _ref3.reducers;
  return {
    menu: [].concat(menu, getMenuItems(_module)),
    routes: [].concat(routes, getRoutes(_module)),
    messages: _lodash.default.merge(messages, getMessages(_module)),
    reducers: Object.assign({}, reducers, getReducers(_module))
  };
};

var render = function render(config) {
  var rootId = config.rootId,
      basename = config.basename,
      modules = config.modules,
      analytics = config.analytics,
      _config$notifications = config.notifications,
      notifications = _config$notifications === void 0 ? {} : _config$notifications,
      _config$intl = config.intl,
      intl = _config$intl === void 0 ? {
    locale: 'en',
    defaultLocale: 'en'
  } : _config$intl,
      authentication = config.authentication,
      _config$CustomProvide = config.CustomProvider,
      CustomProvider = _config$CustomProvide === void 0 ? _react.Fragment : _config$CustomProvide,
      _config$RouterLayout = config.RouterLayout,
      RouterLayout = _config$RouterLayout === void 0 ? _react.Fragment : _config$RouterLayout,
      _config$ErrorHandler = config.ErrorHandler,
      ErrorHandler = _config$ErrorHandler === void 0 ? _GlobalErrorHandler.default : _config$ErrorHandler;

  var _modules$reduce = modules.reduce(moduleReducer, {
    menu: config.menu || [],
    routes: [],
    messages: {},
    reducers: {}
  }),
      menu = _modules$reduce.menu,
      routes = _modules$reduce.routes,
      messages = _modules$reduce.messages,
      reducers = _modules$reduce.reducers;

  var store = (0, _redux.createStore)((0, _redux.combineReducers)(reducers));
  var locale = intl.locale || intl.defaultLocale;
  var defaultLocale = intl.defaultLocale || 'en';
  var AuthenticationProvider = authentication ? _auth.AuthProvider : _react.Fragment;

  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_analytics.AnalyticsProvider, {
    config: analytics
  }, /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    store: store
  }, /*#__PURE__*/_react.default.createElement(_i18n.IntlProvider, {
    locale: locale,
    defaultLocale: defaultLocale,
    messages: messages
  }, /*#__PURE__*/_react.default.createElement(_GlobalComponentsContext.GlobalComponentsProvider, {
    components: {
      RouterLayout: RouterLayout,
      ErrorHandler: ErrorHandler
    }
  }, /*#__PURE__*/_react.default.createElement(AuthenticationProvider, {
    authentication: authentication
  }, /*#__PURE__*/_react.default.createElement(_NotificationsProvider.default, notifications, /*#__PURE__*/_react.default.createElement(CustomProvider, null, /*#__PURE__*/_react.default.createElement(_router.Router, {
    routes: routes,
    menu: menu,
    basename: basename
  })))))))), document.getElementById(rootId));
};

exports.render = render;
var _default = render;
exports.default = _default;